/*
================================================================ 
     Copyright (c) 2018-2020 Digitize Things Inc.           
           All rights reserved.                       
================================================================ 
*/

import React, { useEffect, useState, useRef } from "react";
import classes from "../checkout.module.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import totalCalculator from "../../../../helper/totalCalculatorNew";
import { withTranslation } from "react-i18next";
import Input from "../../../../component/inputpm";
import { TableContainer, Tooltip } from "@mui/material";
import currencyFormatter from "../../../../helper/currencyFormatter";
import Collapse from "@mui/material/Collapse";
import { connect } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import ClearIconMUI from "@mui/icons-material/Clear";
import AddIcon from "@mui/icons-material/Add";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import ManageCustomersHierarchy from "../../manageCustomers/manageCustomersHierarchy";
import Button from "../../../../component/button";
import Card from "@mui/material/Card";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import {
  DeleteIconNew,
  EditIconNew,
  EnterArrow,
  PlusIcon,
  RefreshIcon,
  ClipboardWithGear,
} from "../../../../component/icons/icons";
import Grid from "@mui/material/Grid";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import ShowNoteDialog from "./showNoteDialog";
import { formatNumber } from "../../../../helper/numberFormatter";
// import { makeStyles } from '@mui/styles';
import OfferingProductSpecCharacteristicsExistingDialog from "../../../pm/component/specification/offeringProductSpecCharacteristicsExistingDialog";
import { formatDate } from "../../../../helper/dateFormatter";

const NewCartBlock = (props) => {
  const t = props.t;
  const [priceDueNow, setPriceDueNow] = useState(0);
  const [priceDueAtInstallation, setPriceDueAtInstallation] = useState(0);
  const [cancellationPriceTotal, setCancellationPriceTotal] = useState(0);
  const [shiftPriceTotal, setShiftPriceTotal] = useState(0);
  const [priceRecurringChargeTotal, setPriceRecurringChargeTotal] = useState(
    [],
  );
  const [priceNTCtotal, setPriceNTCtotal] = useState([]);
  const [expandBom, setExpandBom] = useState(false);
  const [newestNotes, setNewestNotes] = useState(
    props.comments ? props.comments.slice(0, 3) : [],
  );
  const [allNotesOpen, setAllNotesOpen] = useState(false);

  // const useStyles = makeStyles({
  // 	resizablePaper: {
  // 		resize: 'both',
  // 		overflow: 'auto',
  // 		minWidth: 640,
  // 		minHeight: 200,
  // 		maxWidth: '90vw',
  // 		maxHeight: '90vh',
  // 		width: '60vw',
  // 	}
  // });
  // const classess = useStyles();
  useEffect(() => {
    if (props.priceSummaryView) {
      if (props.cartData) {
        calculatePrices();
      }
    }
  }, [props]);
  const checkFulfillable = (value) => {
    if (value === false) {
      return false;
    } else {
      return true;
    }
  };
  const calculatePrices = () => {
    let dueNowTotal = 0;
    let dueAtInstallationTotal = 0;
    let cancellationPriceTotal = 0;
    let shiftPriceTotal = 0;
    var updatedList = [];
    var NTC_List = [];

    let recurringTotal = 0;

    const cartData = props.cartData;
    cartData.forEach((item) => {
      item.cartItem.forEach((cartItem) => {
        cartItem.productOffering.includedItems.forEach((includedItem) => {
          includedItem.otherPrices &&
            includedItem.otherPrices.length > 0 &&
            includedItem.otherPrices.forEach((price) => {
              price.price = Math.round(price.price * 100) / 100;
              if (props.type === "CancelSubscription") {
                switch (price.priceType) {
                  // case "ADVANCE":
                  // case "DEPOSIT":
                  //     dueNowTotal += (price.price * includedItem.quantity) * cartItem.productOffering.quantity;
                  //     break;
                  // case "SETUP_FEE":
                  //     dueAtInstallationTotal += (price.price * includedItem.quantity) * cartItem.productOffering.quantity;
                  //     break;
                  case "RC":
                    recurringTotal +=
                      price.price *
                      includedItem.quantity *
                      cartItem.productOffering.quantity;
                    break;
                  case "CANCELLATION_PRICE":
                    cancellationPriceTotal +=
                      price.price *
                      includedItem.quantity *
                      cartItem.productOffering.quantity;
                    // dueNowTotal += (price.price * includedItem.quantity) * cartItem.productOffering.quantity;
                    break;
                  default:
                    break;
                }
              } else if (props.type === "ShiftSubscription") {
                switch (price.priceType) {
                  // case "ADVANCE":
                  // case "DEPOSIT":
                  //     dueNowTotal += (price.price * includedItem.quantity) * cartItem.productOffering.quantity;
                  //     break;
                  // case "SETUP_FEE":
                  //     dueAtInstallationTotal += (price.price * includedItem.quantity) * cartItem.productOffering.quantity;
                  //     break;
                  // case "RC":
                  //     recurringTotal += (price.price * includedItem.quantity) * cartItem.productOffering.quantity;
                  //     break;
                  case "SHIFT_PRICE":
                    shiftPriceTotal +=
                      price.price *
                      includedItem.quantity *
                      cartItem.productOffering.quantity;
                    // dueNowTotal += (price.price * includedItem.quantity) * cartItem.productOffering.quantity;
                    break;
                  default:
                    break;
                }
              } else {
                switch (price.priceType) {
                  case "ADVANCE":
                  case "DEPOSIT":
                    dueNowTotal +=
                      price.price *
                      includedItem.quantity *
                      cartItem.productOffering.quantity;
                    break;
                  case "SETUP_FEE":
                    dueAtInstallationTotal +=
                      price.price *
                      includedItem.quantity *
                      cartItem.productOffering.quantity;
                    break;
                  case "RC":
                    recurringTotal +=
                      price.price *
                      includedItem.quantity *
                      cartItem.productOffering.quantity;
                    break;
                  // case "CANCELLATION_PRICE":
                  //     cancellationPriceTotal += (price.price * includedItem.quantity) * cartItem.productOffering.quantity;
                  //     break;
                  case "USAGE_CHARGE":
                    var key = `${price.priceTenure}_${price.priceTenureUOM}`;
                    var found = false;
                    for (var k = 0; k < updatedList.length; k++) {
                      if (updatedList[k].key === key) {
                        updatedList[k].price +=
                          price.price *
                          includedItem.quantity *
                          cartItem.productOffering.quantity;
                        found = true;
                        break;
                      }
                    }
                    if (!found) {
                      var newObj = {
                        key: key,
                        termPeriod: price.priceTenure,
                        tenureUom: price.priceTenureUOM,
                        price:
                          price.price *
                          includedItem.quantity *
                          cartItem.productOffering.quantity,
                      };
                      updatedList.push(newObj);
                    }
                    break;
                  default:
                    break;
                }
              }
            });
        });
      });
    });
    cartData.forEach((item) => {
      item.cartItem.forEach((cartItem) => {
        cartItem.productOffering.includedItems.forEach((includedItem) => {
          const originalPrice = JSON.parse(JSON.stringify(includedItem.price));
          includedItem.originalPrice = originalPrice;
          includedItem.price = Math.round(includedItem.price * 100) / 100;
          if (includedItem.priceType === "RC") {
            if (includedItem.priceTerm) {
              var key = `${includedItem.priceTerm.termPeriod}_${includedItem.priceTerm.termUomId}`;
              var found = false;
              for (var k = 0; k < updatedList.length; k++) {
                if (updatedList[k].key === key) {
                  updatedList[k].price +=
                    includedItem.price *
                    includedItem.quantity *
                    cartItem.productOffering.quantity;
                  found = true;
                  break;
                }
              }
              if (!found) {
                var newObj = {
                  key: key,
                  termPeriod: includedItem.priceTerm.termPeriod,
                  tenureUom: includedItem.priceTerm.termUomId,
                  price:
                    includedItem.price *
                    includedItem.quantity *
                    cartItem.productOffering.quantity,
                };
                updatedList.push(newObj);
              }
            }
          } else if (includedItem.priceType === "NTC") {
            if (includedItem.priceTerm) {
              var key = `${includedItem.priceTerm.termPeriod}_${includedItem.priceTerm.termUomId}`;
              var found = false;
              for (var k = 0; k < NTC_List.length; k++) {
                if (NTC_List[k].key === key) {
                  NTC_List[k].price +=
                    includedItem.price *
                    includedItem.quantity *
                    cartItem.productOffering.quantity;
                  found = true;
                  break;
                }
              }
              if (!found) {
                var newObj = {
                  key: key,
                  termPeriod: includedItem.priceTerm.termPeriod,
                  tenureUom: includedItem.priceTerm.termUomId,
                  price:
                    includedItem.price *
                    includedItem.quantity *
                    cartItem.productOffering.quantity,
                };
                NTC_List.push(newObj);
              }
            }
          } else {
            dueAtInstallationTotal +=
              includedItem.price *
              includedItem.quantity *
              cartItem.productOffering.quantity;
          }
        });
      });
    });
    setPriceDueNow(dueNowTotal);
    setPriceDueAtInstallation(dueAtInstallationTotal);
    setPriceRecurringChargeTotal(updatedList);
    setCancellationPriceTotal(cancellationPriceTotal);
    setShiftPriceTotal(shiftPriceTotal);
    setPriceNTCtotal(NTC_List);
  };
  const handleExpandBom = () => {
    setExpandBom((prevExpandBom) => !prevExpandBom);
  };

  const getPriceTenureUOM = (val) => {
    // console.log('getpricetemure===', val);
    if (val === "TF_day") {
      return "Day";
    } else if (val === "TF_hr" || val === "HOUR") {
      return "Hour";
    } else if (val === "TF_wk") {
      return "Week";
    } else if (val === "TF_mon") {
      return "Month";
    } else if (val === "TF_yr") {
      return "Year";
    } else if (val === "YEAR") {
      return "Year";
    } else if (val === "DAY") {
      return "Day";
    } else if (val === "WEEK") {
      return "Week";
    } else if (val === "MONTH") {
      return "Month";
    } else if (val === "TF_hr") {
      return "Hour";
    } else if (val === "DATA_MB") {
      return "MB";
    } else if (val === "DATA_GB") {
      return "GB";
    } else {
      return "";
    }
  };

  const numbersOnly = (e) => {
    // List of keys to block: +, -, e, E
    if (["+", "-", "e", "E"].includes(e.key)) {
      e.preventDefault(); // Block the key
    }
  };

  const [showNote, setShowNote] = useState(false);
  const [noteData, setNotedata] = useState({});
  const showFullNote = (note) => {
    setNotedata(note);
    setShowNote(true);
  };
  const closeFullNote = () => {
    setNotedata({});
    setShowNote(false);
  };

  const handleOpenAllNotes = () => {
    setAllNotesOpen(true);
  };

  const handleCloseAllNotes = () => {
    setAllNotesOpen(false);
  };

  const DraggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  const handleCloseSpecificationDialog = () => { };

  return (
    <div>
      <Grid
        item
        style={{ display: "flex", justifyContent: "space-between" }}
        size={{
          xs: 12,
          md: 8,
        }}
      >
        <div>
          <h3 style={{ marginTop: 0 }}>
            {props.screen === "quote" ? t("QUOTE_ITEMS") : t("ORDER_ITEMS")}
          </h3>
        </div>
      </Grid>
      <Grid container spacing={1}>
        {props.priceSummaryView ? (
          props.cartData && props.cartData.length > 0 ? (
            <>
              <Grid
                item
                className={classes.cartItemContainer}
                size={{
                  xs: 12,
                  md: 8,
                }}
              >
                {props.cartData[0].cartItem
                  .sort((a, b) => (a && b ? a.index - b.index : 0))
                  .map((item, i) => (
                    <React.Fragment key={i}>
                      <Card
                        variant="outlined"
                        className={"roundCorners " + classes.cartItemCard}
                      >
                        <Grid container className={classes.cardItemHeader}>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 8,
                            }}
                          >
                            <b>{item.productOffering.name}</b>
                            {props.screen === "checkout" ? (
                              ""
                            ) : (
                              <>
                                {(props.type === "NewActivation" ||
                                  props.type === "ChangeSubscription") &&
                                  props.edit.quantity && (
                                    <Tooltip title={t("EDIT")}>
                                      <IconButton
                                        className="buttonSecondary"
                                        onClick={() =>
                                          props.reviseOffering(item)
                                        }
                                      >
                                        <EditIconNew />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                {(props.type === "ShiftSubscription" ||
                                  props.type === "CancelSubscription") &&
                                  props.edit.quantity &&
                                  item.editable && (
                                    <Tooltip title={t("EDIT")}>
                                      <IconButton
                                        className="buttonSecondary"
                                        onClick={() =>
                                          props.reviseOffering(item)
                                        }
                                      >
                                        <EditIconNew />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                              </>
                            )}
                          </Grid>
                          <Grid
                            item
                            justifyContent="flex-end"
                            size={{
                              xs: 12,
                              md: 4,
                            }}
                          >
                            {props.screen === "checkout" ? (
                              <>
                                <Input
                                  className={classes.quantityInput}
                                  type="number"
                                  min="1"
                                  step="1"
                                  value={item.productOffering.quantity}
                                  onChange={(e) => {
                                    props.screen === "quote"
                                      ? props.tempChangePSQuantity(e, item)
                                      : props.changeQuantity(e, item);
                                  }}
                                  onBlur={(e) => {
                                    props.screen === "quote" &&
                                      props.tempChangePSQuantityVerify(e, item);
                                  }}
                                  onKeyDown={(e) => {
                                    props.screen === "quote" &&
                                      props.changePSQuantity(e, item);
                                  }}
                                  style={{ background: "#fff" }}
                                  disabled={!props.edit.quantity}
                                />
                                {/* {props.edit.remove &&
																	<Tooltip title={t("DELETE")}>
																		<IconButton
																			className="buttonSecondary"
																			onClick={() => {
																				props.removePSFromCart(item);
																			}}
																			style={{ marginRight: "15px", marginTop: "4px" }}
																		>
																			<DeleteIconNew />
																		</IconButton>
																	</Tooltip>
																} */}
                              </>
                            ) : (
                              <>
                                {props.edit.quantity && item.editable ? (
                                  <Input
                                    className={classes.quantityInput}
                                    type="number"
                                    min="1"
                                    step="1"
                                    value={item.productOffering.quantity}
                                    onChange={(e) => {
                                      props.screen === "quote"
                                        ? props.tempChangePSQuantity(e, item)
                                        : props.changeQuantity(e, item);
                                    }}
                                    onBlur={(e) => {
                                      props.screen === "quote" &&
                                        props.tempChangePSQuantityVerify(
                                          e,
                                          item,
                                        );
                                    }}
                                    onKeyDown={(e) => {
                                      props.screen === "quote" &&
                                        props.changePSQuantity(e, item);
                                    }}
                                    style={{ background: "#fff" }}
                                  />
                                ) : (
                                  <Input
                                    className={classes.quantityInput}
                                    type="number"
                                    min="1"
                                    step="1"
                                    value={item.productOffering.quantity}
                                    onChange={(e) => {
                                      props.changeQuantity(e, item);
                                    }}
                                    style={{ background: "#fff" }}
                                    disabled
                                  />
                                )}
                                {props.edit.remove && item.editable ? (
                                  <Tooltip title={t("DELETE")}>
                                    <IconButton
                                      className="buttonSecondary"
                                      onClick={() => {
                                        props.showRemoveItemWarning(item);
                                      }}
                                      style={{
                                        marginRight: "15px",
                                        marginTop: "4px",
                                      }}
                                    >
                                      <DeleteIconNew />
                                    </IconButton>
                                  </Tooltip>
                                ) : null}
                              </>
                            )}
                          </Grid>
                        </Grid>
                        <div className={classes.subscriptionDetails}>
                          {props.cartData[0].subscriptionId &&
                            props.cartData[0].typeDescription && (
                              <p
                                style={{ margin: 0 }}
                              >{`${props.cartData[0].typeDescription} Subscription for ${item.productOffering.parentSubscriptionName ?? ""} (Subscription Id: ${item.productOffering.parentSubscriptionId ?? ""})`}</p>
                            )}
                        </div>
                        <div className={classes.includedItemsTable}>
                          <TableContainer>
                            <Table className="newGlobalTable roundCorners">
                              <TableHead>
                                <TableRow>
                                  <TableCell
                                    colSpan={
                                      props.providerType !== "SOLUTION_PROVIDER"
                                        ? 1
                                        : 4
                                    }
                                  >
                                    {t("ITEM_DESCRIPTION")}
                                  </TableCell>
                                  {props.providerType ===
                                    "SALES_CHNL_PROVIDER" && (
                                      <>
                                        <TableCell align="right">
                                          {t("QUANTITY")}
                                        </TableCell>
                                        <TableCell align="right">
                                          {t("UNIT_PRICE")}
                                        </TableCell>
                                        <TableCell align="right">
                                          {t("TOTAL_PRICE")}
                                        </TableCell>
                                      </>
                                    )}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {item.productOffering.includedItems.map(
                                  (aItem, aIndex) =>
                                    checkFulfillable(aItem.fulfillable) &&
                                    aItem.customerViewable && (
                                      <>
                                        <TableRow key={aIndex} className="">
                                          <TableCell colSpan={4}>
                                            {formatNumber(aItem.quantity *
                                              item.productOffering
                                                .quantity)}{" "}
                                            x <b>{aItem.name}</b>
                                            {props.screen &&
                                              props.screen === "checkout" &&
                                              aItem.productSpec &&
                                              aItem.productSpec.category && (
                                                <Tooltip
                                                  title={t(
                                                    "PRODUCT_SPECIFICATION",
                                                  )}
                                                >
                                                  <span
                                                    onClick={() =>
                                                      props.openProductSpecification(
                                                        item,
                                                        aItem,
                                                      )
                                                    }
                                                    style={{
                                                      display: "inline-flex",
                                                      position: "relative",
                                                      marginLeft: "10px",
                                                      top: "3px",
                                                    }}
                                                  >
                                                    <ClipboardWithGear />
                                                  </span>
                                                </Tooltip>
                                              )}
                                          </TableCell>
                                        </TableRow>
                                        {props.providerType !==
                                          "SOLUTION_PROVIDER" &&
                                          (aItem.recurringCost?.some(
                                            (charge) => charge.price > 0,
                                          ) ||
                                            Number(
                                              aItem.specialPrice ||
                                              aItem.price ||
                                              aItem.depositPrice ||
                                              aItem.setupFee ||
                                              aItem.cancellationPrice ||
                                              aItem.nonRecurringCost ||
                                              aItem.shiftPrice,
                                            ) > 0 ||
                                            aItem.otherPrices?.some(
                                              (op) => Number(op.price) > 0,
                                            )) && (
                                            <>
                                              {aItem.nonRecurringCost &&
                                                Number(aItem.nonRecurringCost) >
                                                0 ? (
                                                <TableRow>
                                                  <TableCell>
                                                    <span
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <EnterArrow />
                                                      {t("NRC_FULL")}
                                                    </span>
                                                  </TableCell>
                                                  <TableCell align="right">
                                                    {props.providerType ===
                                                      "SALES_CHNL_PROVIDER" ||
                                                      props.publicBrowsing ? (
                                                      <>
                                                        {/* ({aItem.quantity * item.productOffering.quantity} x {currencyFormatter(aItem.specialPrice ? aItem.specialPrice : aItem.price)}) */}
                                                        {formatNumber(aItem.quantity *
                                                          item.productOffering
                                                            .quantity)}
                                                      </>
                                                    ) : (
                                                      <>
                                                        {formatNumber(aItem.quantity *
                                                          item.productOffering
                                                            .quantity)}
                                                      </>
                                                    )}
                                                  </TableCell>
                                                  <TableCell align="right">
                                                    {props.providerType ===
                                                      "SALES_CHNL_PROVIDER" ? (
                                                      <>
                                                        {currencyFormatter(
                                                          Math.round(
                                                            aItem.specialPrice
                                                              ? aItem.specialPrice
                                                              : aItem.nonRecurringCost *
                                                              100,
                                                          ) / 100,
                                                        )}
                                                      </>
                                                    ) : (
                                                      currencyFormatter(
                                                        0,
                                                        false,
                                                      )
                                                    )}
                                                  </TableCell>

                                                  <TableCell align="right">
                                                    {props.providerType ===
                                                      "SALES_CHNL_PROVIDER" ? (
                                                      <>
                                                        {currencyFormatter(
                                                          Math.round(
                                                            (aItem.specialPrice
                                                              ? aItem.specialPrice
                                                              : aItem.nonRecurringCost) *
                                                            aItem.quantity *
                                                            item
                                                              .productOffering
                                                              .quantity *
                                                            100,
                                                          ) / 100,
                                                        )}
                                                      </>
                                                    ) : (
                                                      currencyFormatter(
                                                        0,
                                                        false,
                                                      )
                                                    )}
                                                  </TableCell>
                                                </TableRow>
                                              ) : (
                                                ""
                                              )}
                                              {aItem.recurringCost &&
                                                aItem.recurringCost.map(
                                                  (charge, index) => {
                                                    const {
                                                      key,
                                                      termPeriod,
                                                      tenureUom,
                                                      price,
                                                    } = charge;
                                                    const displayText =
                                                      termPeriod > 1
                                                        ? `${t("RC_FULL")} (per ${termPeriod} ${getPriceTenureUOM(tenureUom)}s)`
                                                        : `${t("RC_FULL")} (per ${getPriceTenureUOM(tenureUom)})`;

                                                    return (
                                                      price > 0 && (
                                                        <TableRow key={index}>
                                                          <TableCell>
                                                            <span
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                              }}
                                                            >
                                                              <EnterArrow />
                                                              {displayText}
                                                            </span>
                                                          </TableCell>
                                                          <TableCell align="right">
                                                            {props.providerType ===
                                                              "SALES_CHNL_PROVIDER" ||
                                                              props.publicBrowsing ? (
                                                              <>
                                                                {formatNumber(aItem.quantity *
                                                                  item
                                                                    .productOffering
                                                                    .quantity)}
                                                              </>
                                                            ) : (
                                                              <>
                                                                {formatNumber(aItem.quantity *
                                                                  item
                                                                    .productOffering
                                                                    .quantity)}
                                                              </>
                                                            )}
                                                          </TableCell>
                                                          <TableCell align="right">
                                                            {props.providerType ===
                                                              "SALES_CHNL_PROVIDER" ? (
                                                              <>
                                                                {currencyFormatter(
                                                                  Math.round(
                                                                    (aItem.specialPrice
                                                                      ? aItem.specialPrice
                                                                      : price) *
                                                                    100,
                                                                  ) / 100,
                                                                )}
                                                              </>
                                                            ) : (
                                                              currencyFormatter(
                                                                0,
                                                                false,
                                                              )
                                                            )}
                                                          </TableCell>

                                                          <TableCell align="right">
                                                            {props.providerType ===
                                                              "SALES_CHNL_PROVIDER" ? (
                                                              <>
                                                                {currencyFormatter(
                                                                  Math.round(
                                                                    (aItem.specialPrice
                                                                      ? aItem.specialPrice
                                                                      : price) *
                                                                    aItem.quantity *
                                                                    item
                                                                      .productOffering
                                                                      .quantity *
                                                                    100,
                                                                  ) / 100,
                                                                )}
                                                              </>
                                                            ) : (
                                                              <>
                                                                {currencyFormatter(
                                                                  0,
                                                                  false,
                                                                )}
                                                              </>
                                                            )}
                                                          </TableCell>
                                                        </TableRow>
                                                      )
                                                    );
                                                  },
                                                )}

                                              {!aItem.nonRecurringCost &&
                                                !aItem.recurringCost && (
                                                  // (Number(aItem.specialPrice ? aItem.specialPrice : aItem.price) > 0) &&
                                                  <>
                                                    {aItem.priceType !== "RC" &&
                                                      Number(
                                                        aItem.specialPrice
                                                          ? aItem.specialPrice
                                                          : aItem.price,
                                                      ) > 0 && (
                                                        <TableRow>
                                                          <TableCell>
                                                            <span
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                              }}
                                                            >
                                                              <EnterArrow />
                                                              {aItem.priceType ===
                                                                "NTC"
                                                                ? aItem
                                                                  .priceTerm
                                                                  .termPeriod >
                                                                  1
                                                                  ? `${t("NTC_FULL")} (per ${getPriceTenureUOM(aItem.priceTerm.termUomId)} for ${aItem
                                                                    .priceTerm
                                                                    .termPeriod
                                                                  } ${getPriceTenureUOM(aItem.priceTerm.termUomId)}s)`
                                                                  : `${t("NTC_FULL")} (per ${getPriceTenureUOM(aItem.priceTerm.termUomId)} for ${aItem
                                                                    .priceTerm
                                                                    .termPeriod
                                                                  } ${getPriceTenureUOM(aItem.priceTerm.termUomId)})`
                                                                : t("NRC_FULL")}
                                                            </span>
                                                          </TableCell>
                                                          <TableCell align="right">
                                                            {props.providerType ===
                                                              "SALES_CHNL_PROVIDER" ||
                                                              props.publicBrowsing ? (
                                                              <>
                                                                {/* ({aItem.quantity * item.productOffering.quantity} x {currencyFormatter(aItem.specialPrice ? aItem.specialPrice : aItem.price)}) */}
                                                                {formatNumber(aItem.quantity *
                                                                  item
                                                                    .productOffering
                                                                    .quantity)}
                                                              </>
                                                            ) : (
                                                              <>
                                                                {formatNumber(aItem.quantity *
                                                                  item
                                                                    .productOffering
                                                                    .quantity)}
                                                              </>
                                                            )}
                                                          </TableCell>
                                                          <TableCell align="right">
                                                            {currencyFormatter(
                                                              aItem.specialPrice
                                                                ? aItem.specialPrice
                                                                : aItem.price,
                                                            )}
                                                          </TableCell>

                                                          <TableCell align="right">
                                                            {props.providerType ===
                                                              "SALES_CHNL_PROVIDER" ? (
                                                              <>
                                                                {currencyFormatter(
                                                                  (aItem.specialPrice
                                                                    ? aItem.specialPrice
                                                                    : aItem.originalPrice ? aItem.originalPrice : aItem.price) *
                                                                  aItem.quantity *
                                                                  item
                                                                    .productOffering
                                                                    .quantity,
                                                                )}
                                                              </>
                                                            ) : (
                                                              currencyFormatter(
                                                                0,
                                                                false,
                                                              )
                                                            )}
                                                          </TableCell>
                                                        </TableRow>
                                                      )}
                                                    {aItem.priceType === "RC" &&
                                                      Number(
                                                        aItem.specialPrice
                                                          ? aItem.specialPrice
                                                          : aItem.price,
                                                      ) > 0 && (
                                                        <TableRow>
                                                          <TableCell>
                                                            <span
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                              }}
                                                            >
                                                              <EnterArrow />
                                                              {t("RC_FULL")}
                                                              {aItem.priceTerm &&
                                                                (aItem.priceTerm
                                                                  .termPeriod
                                                                  ? aItem
                                                                    .priceTerm
                                                                    .termPeriod >
                                                                    1
                                                                    ? " (" +
                                                                    "per " +
                                                                    aItem
                                                                      .priceTerm
                                                                      .termPeriod +
                                                                    " " +
                                                                    getPriceTenureUOM(
                                                                      aItem
                                                                        .priceTerm
                                                                        .termUomId,
                                                                    ) +
                                                                    "s" +
                                                                    ")"
                                                                    : " (" +
                                                                    "per " +
                                                                    getPriceTenureUOM(
                                                                      aItem
                                                                        .priceTerm
                                                                        .termUomId,
                                                                    ) +
                                                                    ")"
                                                                  : "")}
                                                            </span>
                                                          </TableCell>
                                                          <TableCell align="right">
                                                            {props.providerType ===
                                                              "SALES_CHNL_PROVIDER" ||
                                                              props.publicBrowsing ? (
                                                              <>
                                                                {/* ({aItem.quantity * item.productOffering.quantity} x {currencyFormatter(aItem.specialPrice ? aItem.specialPrice : aItem.price)}) */}
                                                                {formatNumber(aItem.quantity *
                                                                  item
                                                                    .productOffering
                                                                    .quantity)}
                                                              </>
                                                            ) : (
                                                              <>
                                                                {formatNumber(aItem.quantity *
                                                                  item
                                                                    .productOffering
                                                                    .quantity)}
                                                              </>
                                                            )}
                                                          </TableCell>
                                                          <TableCell align="right">
                                                            {props.providerType ===
                                                              "SALES_CHNL_PROVIDER" ? (
                                                              <>
                                                                {currencyFormatter(
                                                                  Math.round(
                                                                    (aItem.specialPrice
                                                                      ? aItem.specialPrice
                                                                      : aItem.price) *
                                                                    100,
                                                                  ) / 100,
                                                                )}
                                                              </>
                                                            ) : (
                                                              currencyFormatter(
                                                                0,
                                                                false,
                                                              )
                                                            )}
                                                          </TableCell>

                                                          <TableCell align="right">
                                                            {props.providerType ===
                                                              "SALES_CHNL_PROVIDER" ? (
                                                              <>
                                                                {currencyFormatter(
                                                                  Math.round(
                                                                    (aItem.specialPrice
                                                                      ? aItem.specialPrice
                                                                      : aItem.originalPrice ? aItem.originalPrice : aItem.price) *
                                                                    aItem.quantity *
                                                                    item
                                                                      .productOffering
                                                                      .quantity *
                                                                    100,
                                                                  ) / 100,
                                                                )}
                                                              </>
                                                            ) : (
                                                              currencyFormatter(
                                                                0,
                                                                false,
                                                              )
                                                            )}
                                                          </TableCell>
                                                        </TableRow>
                                                      )}
                                                    {aItem.otherPrices &&
                                                      aItem.otherPrices.length >
                                                      0 &&
                                                      aItem.otherPrices.map(
                                                        (op, opx) =>
                                                          Number(
                                                            aItem.specialPrice
                                                              ? aItem.specialPrice
                                                              : op.price,
                                                          ) > 0 &&
                                                            op.priceType ===
                                                            "CANCELLATION_PRICE" ? (
                                                            <>
                                                              {props.type ===
                                                                "CancelSubscription" && (
                                                                  <TableRow
                                                                    key={opx}
                                                                  >
                                                                    <TableCell>
                                                                      <span
                                                                        style={{
                                                                          display:
                                                                            "flex",
                                                                          alignItems:
                                                                            "center",
                                                                        }}
                                                                      >
                                                                        <EnterArrow />
                                                                        {t(
                                                                          op.priceType,
                                                                        )}
                                                                      </span>
                                                                      {op.priceTenure !==
                                                                        null &&
                                                                        op.priceTenureUOM && (
                                                                          <span>
                                                                            {op.priceTenure >
                                                                              1
                                                                              ? ` (per ${op.priceTenure} ${getPriceTenureUOM(op.priceTenureUOM)}s)`
                                                                              : ` (per ${getPriceTenureUOM(op.priceTenureUOM)})`}
                                                                          </span>
                                                                        )}
                                                                    </TableCell>
                                                                    <TableCell align="right">
                                                                      {props.providerType ===
                                                                        "SALES_CHNL_PROVIDER" ||
                                                                        props.publicBrowsing ? (
                                                                        <>
                                                                          {/* ({aItem.quantity * item.productOffering.quantity} x {currencyFormatter(aItem.specialPrice ? aItem.specialPrice : aItem.price)}) */}
                                                                          {formatNumber(aItem.quantity *
                                                                            item
                                                                              .productOffering
                                                                              .quantity)}
                                                                        </>
                                                                      ) : (
                                                                        <>
                                                                          {formatNumber(aItem.quantity *
                                                                            item
                                                                              .productOffering
                                                                              .quantity)}
                                                                        </>
                                                                      )}
                                                                    </TableCell>
                                                                    <TableCell align="right">
                                                                      {props.providerType ===
                                                                        "SALES_CHNL_PROVIDER" ? (
                                                                        <>
                                                                          {currencyFormatter(
                                                                            Math.round(
                                                                              (aItem.specialPrice
                                                                                ? aItem.specialPrice
                                                                                : op.price) *
                                                                              100,
                                                                            ) /
                                                                            100,
                                                                          )}
                                                                        </>
                                                                      ) : (
                                                                        currencyFormatter(
                                                                          0,
                                                                          false,
                                                                        )
                                                                      )}
                                                                    </TableCell>

                                                                    <TableCell align="right">
                                                                      {props.providerType ===
                                                                        "SALES_CHNL_PROVIDER" ? (
                                                                        <>
                                                                          {currencyFormatter(
                                                                            Math.round(
                                                                              (aItem.specialPrice
                                                                                ? aItem.specialPrice
                                                                                : op.price) *
                                                                              aItem.quantity *
                                                                              item
                                                                                .productOffering
                                                                                .quantity *
                                                                              100,
                                                                            ) /
                                                                            100,
                                                                          )}
                                                                        </>
                                                                      ) : (
                                                                        currencyFormatter(
                                                                          0,
                                                                          false,
                                                                        )
                                                                      )}
                                                                    </TableCell>
                                                                    {/* <TableCell align='right'>{currencyFormatter(0)}</TableCell> */}
                                                                  </TableRow>
                                                                )}
                                                            </>
                                                          ) : (
                                                            <TableRow key={opx}>
                                                              <TableCell>
                                                                <span
                                                                  style={{
                                                                    display:
                                                                      "flex",
                                                                    alignItems:
                                                                      "center",
                                                                  }}
                                                                >
                                                                  <EnterArrow />
                                                                  {t(
                                                                    op.priceType,
                                                                  )}
                                                                </span>
                                                                {op.priceTenure !==
                                                                  null &&
                                                                  op.priceTenureUOM && (
                                                                    <span>
                                                                      {op.priceTenure >
                                                                        1
                                                                        ? ` (per ${op.priceTenure} ${getPriceTenureUOM(op.priceTenureUOM)}s)`
                                                                        : ` (per ${getPriceTenureUOM(op.priceTenureUOM)})`}
                                                                    </span>
                                                                  )}
                                                              </TableCell>
                                                              <TableCell align="right">
                                                                {props.providerType ===
                                                                  "SALES_CHNL_PROVIDER" ||
                                                                  props.publicBrowsing ? (
                                                                  <>
                                                                    {/* ({aItem.quantity * item.productOffering.quantity} x {currencyFormatter(aItem.specialPrice ? aItem.specialPrice : aItem.price)}) */}
                                                                    {formatNumber(aItem.quantity *
                                                                      item
                                                                        .productOffering
                                                                        .quantity)}
                                                                  </>
                                                                ) : (
                                                                  <>
                                                                    {formatNumber(aItem.quantity *
                                                                      item
                                                                        .productOffering
                                                                        .quantity)}
                                                                  </>
                                                                )}
                                                              </TableCell>
                                                              <TableCell align="right">
                                                                {props.providerType ===
                                                                  "SALES_CHNL_PROVIDER" ? (
                                                                  <>
                                                                    {currencyFormatter(
                                                                      Math.round(
                                                                        (aItem.specialPrice
                                                                          ? aItem.specialPrice
                                                                          : op.price) *
                                                                        100,
                                                                      ) / 100,
                                                                    )}
                                                                  </>
                                                                ) : (
                                                                  currencyFormatter(
                                                                    0,
                                                                    false,
                                                                  )
                                                                )}
                                                              </TableCell>

                                                              <TableCell align="right">
                                                                {props.providerType ===
                                                                  "SALES_CHNL_PROVIDER" ? (
                                                                  <>
                                                                    {currencyFormatter(
                                                                      Math.round(
                                                                        (aItem.specialPrice
                                                                          ? aItem.specialPrice
                                                                          : op.price) *
                                                                        aItem.quantity *
                                                                        item
                                                                          .productOffering
                                                                          .quantity *
                                                                        100,
                                                                      ) / 100,
                                                                    )}
                                                                  </>
                                                                ) : (
                                                                  currencyFormatter(
                                                                    0,
                                                                    false,
                                                                  )
                                                                )}
                                                              </TableCell>
                                                              {/* <TableCell align='right'>{currencyFormatter(0)}</TableCell> */}
                                                            </TableRow>
                                                          ),
                                                      )}
                                                  </>
                                                )}
                                              {aItem.depositPrice &&
                                                Number(
                                                  aItem.specialPrice
                                                    ? aItem.specialPrice
                                                    : aItem.depositPrice,
                                                ) > 0 ? (
                                                <TableRow>
                                                  <TableCell>
                                                    <span
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <EnterArrow />
                                                      {t("DEPOSIT_PRICE")}
                                                    </span>
                                                  </TableCell>
                                                  <TableCell align="right">
                                                    {props.providerType ===
                                                      "SALES_CHNL_PROVIDER" ||
                                                      props.publicBrowsing ? (
                                                      <>
                                                        {/* ({aItem.quantity * item.productOffering.quantity} x {currencyFormatter(aItem.specialPrice ? aItem.specialPrice : aItem.price)}) */}
                                                        {formatNumber(aItem.quantity *
                                                          item.productOffering
                                                            .quantity)}
                                                      </>
                                                    ) : (
                                                      <>
                                                        {formatNumber(aItem.quantity *
                                                          item.productOffering
                                                            .quantity)}
                                                      </>
                                                    )}
                                                  </TableCell>
                                                  <TableCell align="right">
                                                    {props.providerType ===
                                                      "SALES_CHNL_PROVIDER" ? (
                                                      <>
                                                        {currencyFormatter(
                                                          Math.round(
                                                            (aItem.specialPrice
                                                              ? aItem.specialPrice
                                                              : aItem.depositPrice) *
                                                            100,
                                                          ) / 100,
                                                        )}
                                                      </>
                                                    ) : (
                                                      currencyFormatter(
                                                        0,
                                                        false,
                                                      )
                                                    )}
                                                  </TableCell>

                                                  <TableCell align="right">
                                                    {props.providerType ===
                                                      "SALES_CHNL_PROVIDER" ? (
                                                      <>
                                                        {currencyFormatter(
                                                          Math.round(
                                                            (aItem.specialPrice
                                                              ? aItem.specialPrice
                                                              : aItem.depositPrice) *
                                                            aItem.quantity *
                                                            item
                                                              .productOffering
                                                              .quantity *
                                                            100,
                                                          ) / 100,
                                                        )}
                                                      </>
                                                    ) : (
                                                      currencyFormatter(
                                                        0,
                                                        false,
                                                      )
                                                    )}
                                                  </TableCell>
                                                  {/* <TableCell align='right'>{currencyFormatter(0)}</TableCell> */}
                                                </TableRow>
                                              ) : (
                                                ""
                                              )}
                                              {aItem.setupFee &&
                                                Number(
                                                  aItem.specialPrice
                                                    ? aItem.specialPrice
                                                    : aItem.setupFee,
                                                ) > 0 ? (
                                                <TableRow>
                                                  <TableCell>
                                                    <span
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <EnterArrow />
                                                      {t("SETUP_FEE")}
                                                    </span>
                                                  </TableCell>
                                                  <TableCell align="right">
                                                    {props.providerType ===
                                                      "SALES_CHNL_PROVIDER" ||
                                                      props.publicBrowsing ? (
                                                      <>
                                                        {/* ({aItem.quantity * item.productOffering.quantity} x {currencyFormatter(aItem.specialPrice ? aItem.specialPrice : aItem.price)}) */}
                                                        {formatNumber(aItem.quantity *
                                                          item.productOffering
                                                            .quantity)}
                                                      </>
                                                    ) : (
                                                      <>
                                                        {formatNumber(aItem.quantity *
                                                          item.productOffering
                                                            .quantity)}
                                                      </>
                                                    )}
                                                  </TableCell>
                                                  <TableCell align="right">
                                                    {props.providerType ===
                                                      "SALES_CHNL_PROVIDER" ? (
                                                      <>
                                                        {currencyFormatter(
                                                          Math.round(
                                                            (aItem.specialPrice
                                                              ? aItem.specialPrice
                                                              : aItem.setupFee) *
                                                            100,
                                                          ) / 100,
                                                        )}
                                                      </>
                                                    ) : (
                                                      currencyFormatter(
                                                        0,
                                                        false,
                                                      )
                                                    )}
                                                  </TableCell>

                                                  <TableCell align="right">
                                                    {props.providerType ===
                                                      "SALES_CHNL_PROVIDER" ? (
                                                      <>
                                                        {currencyFormatter(
                                                          Math.round(
                                                            (aItem.specialPrice
                                                              ? aItem.specialPrice
                                                              : aItem.setupFee) *
                                                            aItem.quantity *
                                                            item
                                                              .productOffering
                                                              .quantity *
                                                            100,
                                                          ) / 100,
                                                        )}
                                                      </>
                                                    ) : (
                                                      currencyFormatter(
                                                        0,
                                                        false,
                                                      )
                                                    )}
                                                  </TableCell>
                                                  {/* <TableCell align='right'>{currencyFormatter(0)}</TableCell> */}
                                                </TableRow>
                                              ) : (
                                                ""
                                              )}
                                              {props.type ===
                                                "CancelSubscription" &&
                                                aItem.cancellationPrice &&
                                                Number(
                                                  aItem.specialPrice
                                                    ? aItem.specialPrice
                                                    : aItem.cancellationPrice,
                                                ) > 0 ? (
                                                <TableRow>
                                                  <TableCell>
                                                    <span
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <EnterArrow />
                                                      {t("CANCELLATION_PRICE")}
                                                    </span>
                                                  </TableCell>
                                                  <TableCell align="right">
                                                    {props.providerType ===
                                                      "SALES_CHNL_PROVIDER" ||
                                                      props.publicBrowsing ? (
                                                      <>
                                                        {/* ({aItem.quantity * item.productOffering.quantity} x {currencyFormatter(aItem.specialPrice ? aItem.specialPrice : aItem.price)}) */}
                                                        {formatNumber(aItem.quantity *
                                                          item.productOffering
                                                            .quantity)}
                                                      </>
                                                    ) : (
                                                      <>
                                                        {formatNumber(aItem.quantity *
                                                          item.productOffering
                                                            .quantity)}
                                                      </>
                                                    )}
                                                  </TableCell>
                                                  <TableCell align="right">
                                                    {props.providerType ===
                                                      "SALES_CHNL_PROVIDER" ? (
                                                      <>
                                                        {currencyFormatter(
                                                          Math.round(
                                                            (aItem.specialPrice
                                                              ? aItem.specialPrice
                                                              : aItem.cancellationPrice) *
                                                            100,
                                                          ) / 100,
                                                        )}
                                                      </>
                                                    ) : (
                                                      currencyFormatter(
                                                        0,
                                                        false,
                                                      )
                                                    )}
                                                  </TableCell>

                                                  <TableCell align="right">
                                                    {props.providerType ===
                                                      "SALES_CHNL_PROVIDER" ? (
                                                      <>
                                                        {currencyFormatter(
                                                          Math.round(
                                                            (aItem.specialPrice
                                                              ? aItem.specialPrice
                                                              : aItem.cancellationPrice) *
                                                            aItem.quantity *
                                                            item
                                                              .productOffering
                                                              .quantity *
                                                            100,
                                                          ) / 100,
                                                        )}
                                                      </>
                                                    ) : (
                                                      currencyFormatter(
                                                        0,
                                                        false,
                                                      )
                                                    )}
                                                  </TableCell>
                                                  {/* <TableCell align='right'>{currencyFormatter(0)}</TableCell> */}
                                                </TableRow>
                                              ) : (
                                                ""
                                              )}
                                              {props.type ===
                                                "ShiftSubscription" &&
                                                aItem.shiftPrice &&
                                                Number(
                                                  aItem.specialPrice
                                                    ? aItem.specialPrice
                                                    : aItem.shiftPrice,
                                                ) > 0 ? (
                                                <TableRow>
                                                  <TableCell>
                                                    <span
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <EnterArrow />
                                                      {t("SHIFT_PRICE")}
                                                    </span>
                                                  </TableCell>
                                                  <TableCell align="right">
                                                    {props.providerType ===
                                                      "SALES_CHNL_PROVIDER" ||
                                                      props.publicBrowsing ? (
                                                      <>
                                                        {/* ({aItem.quantity * item.productOffering.quantity} x {currencyFormatter(aItem.specialPrice ? aItem.specialPrice : aItem.price)}) */}
                                                        {formatNumber(aItem.quantity *
                                                          item.productOffering
                                                            .quantity)}
                                                      </>
                                                    ) : (
                                                      <>
                                                        {formatNumber(aItem.quantity *
                                                          item.productOffering
                                                            .quantity)}
                                                      </>
                                                    )}
                                                  </TableCell>
                                                  <TableCell align="right">
                                                    {props.providerType ===
                                                      "SALES_CHNL_PROVIDER" ? (
                                                      <>
                                                        {currencyFormatter(
                                                          Math.round(
                                                            (aItem.specialPrice
                                                              ? aItem.specialPrice
                                                              : aItem.shiftPrice) *
                                                            100,
                                                          ) / 100,
                                                        )}
                                                      </>
                                                    ) : (
                                                      currencyFormatter(
                                                        0,
                                                        false,
                                                      )
                                                    )}
                                                  </TableCell>

                                                  <TableCell align="right">
                                                    {props.providerType ===
                                                      "SALES_CHNL_PROVIDER" ? (
                                                      <>
                                                        {currencyFormatter(
                                                          Math.round(
                                                            (aItem.specialPrice
                                                              ? aItem.specialPrice
                                                              : aItem.shiftPrice) *
                                                            aItem.quantity *
                                                            item
                                                              .productOffering
                                                              .quantity *
                                                            100,
                                                          ) / 100,
                                                        )}
                                                      </>
                                                    ) : (
                                                      currencyFormatter(
                                                        0,
                                                        false,
                                                      )
                                                    )}
                                                  </TableCell>
                                                  {/* <TableCell align='right'>{currencyFormatter(0)}</TableCell> */}
                                                </TableRow>
                                              ) : (
                                                ""
                                              )}
                                            </>
                                          )}
                                        {/* bom */}
                                        {aItem.bom && aItem.bom.length > 0 && (
                                          <TableContainer>
                                            <Table className="newGlobalTable roundCorners">
                                              <TableHead>
                                                <TableRow>
                                                  <TableCell>
                                                    <span>
                                                      <IconButton
                                                        onClick={
                                                          handleExpandBom
                                                        }
                                                        style={{
                                                          padding:
                                                            "0px !important",
                                                        }}
                                                      >
                                                        {expandBom ? (
                                                          <>
                                                            <KeyboardArrowUp fontSize="small" />
                                                          </>
                                                        ) : (
                                                          <>
                                                            <KeyboardArrowDown fontSize="small" />
                                                          </>
                                                        )}
                                                      </IconButton>
                                                      {expandBom
                                                        ? t("HIDE_BOM_ITEMS")
                                                        : t("SHOW_BOM_ITEMS")}
                                                    </span>
                                                  </TableCell>
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                <TableRow>
                                                  <TableCell>
                                                    <Collapse
                                                      in={expandBom}
                                                      unmountOnExit
                                                    >
                                                      {aItem.bom
                                                        .sort((a, b) =>
                                                          a && b
                                                            ? a.displaySequence -
                                                            b.displaySequence
                                                            : 0,
                                                        )
                                                        .map((bom, index) => (
                                                          <React.Fragment
                                                            key={bom.id}
                                                          >
                                                            <BomItemNew
                                                              data={bom}
                                                              index={index}
                                                              parentItem={aItem}
                                                              level={1}
                                                              t={t}
                                                            />
                                                          </React.Fragment>
                                                        ))}
                                                    </Collapse>
                                                  </TableCell>
                                                </TableRow>
                                              </TableBody>
                                            </Table>
                                          </TableContainer>
                                        )}
                                        {aItem.expandChar && (
                                          <TableRow>
                                            <TableCell colSpan={4}>
                                              <Collapse
                                                in={aItem.expandChar}
                                                unmountOnExit
                                              >
                                                <div
                                                  className={
                                                    classes.planDescription
                                                  }
                                                />
                                                <OfferingProductSpecCharacteristicsExistingDialog
                                                  t={t}
                                                  open={true}
                                                  productId={aItem.id}
                                                  offeringData={item}
                                                  productName={aItem.name}
                                                  onClose={
                                                    handleCloseSpecificationDialog
                                                  }
                                                  componentProductCharacteristics={
                                                    aItem.productSpec
                                                      ? aItem.productSpec
                                                      : {}
                                                  }
                                                  changedCharacteristics={
                                                    aItem.characteristics
                                                      ? aItem.characteristics
                                                      : []
                                                  }
                                                  onCharacteristicsChange={
                                                    props.handleCharacteristicsUpdate
                                                  }
                                                  screen="checkout"
                                                  subScreen={
                                                    props.orderStatus ===
                                                      "ORDER_COMPLETED"
                                                      ? "order"
                                                      : null
                                                  }
                                                />
                                              </Collapse>
                                            </TableCell>
                                          </TableRow>
                                        )}
                                      </>
                                    ),
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      </Card>
                    </React.Fragment>
                  ))}
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 4,
                }}
              >
                <Grid container spacing={1}>
                  {props.providerType === "SALES_CHNL_PROVIDER" &&
                    props.userPerms.includes("CUMULATOR_PROMO_ADMIN") && (
                      <Grid
                        item
                        size={{
                          xs: 12,
                        }}
                      >
                        <Card
                          variant="outlined"
                          className={"roundCorners " + classes.totalsCard}
                        >
                          <b>{t("DISCOUNT_SUMMARY")}</b>
                          <Grid container spacing={1}>
                            <Grid
                              item
                              style={{ marginTop: "0px" }}
                              size={{
                                xs: 12,
                              }}
                            >
                              {props.edit.discount ? (
                                <>
                                  <Input
                                    className={classes.quantityInput}
                                    type="number"
                                    min="1"
                                    step="1"
                                    name="discountPercentage"
                                    value={props.discountPercentage}
                                    onChange={(e) => {
                                      props.changePSDiscountValue(e);
                                    }}
                                    // onChange={(e) => numberInputOnly(e, (value) => {
                                    // 	props.changePSDiscountValue(e)
                                    // })}
                                    placeholder={t("DISCOUNT") + " %"}
                                    style={{
                                      backgroundColor: "#fff",
                                      borderRadius: "5px",
                                      width: "100px",
                                    }}
                                    onKeyDown={(e) => {
                                      numbersOnly(e);
                                    }}
                                  />
                                  <div
                                    style={{
                                      alignContent: "end",
                                      display: "block",
                                    }}
                                  >
                                    <Button
                                      onClick={(e) => {
                                        props.changePSDiscount(e);
                                      }}
                                    >
                                      {t("APPLY_DISCOUNT")}
                                    </Button>
                                  </div>
                                </>
                              ) : (
                                <Input
                                  className={classes.quantityInput}
                                  type="number"
                                  min="1"
                                  step="1"
                                  name="discountPercentage"
                                  value={props.cartData[0].discountPercentage}
                                  onChange={(e) => {
                                    props.changePSDiscountValue(e);
                                  }}
                                  placeholder={t("DISCOUNT") + " %"}
                                  style={{
                                    backgroundColor: "#fff",
                                    borderRadius: "5px",
                                    width: "100px",
                                  }}
                                  // onKeyDown={(e) => {
                                  // 	props.changePSDiscount(e);
                                  // 	if (e.keyCode === 69) {
                                  // 		e.preventDefault();
                                  // 	}
                                  // }}
                                  disabled
                                />
                              )}
                            </Grid>
                            {/* {props.cartData &&
														props.cartData.length > 0 &&
														props.cartData[0].cartTotalPrice &&
														props.cartData[0].cartTotalPrice.length > 0 && (
															<Grid item xs={12} justifyContent="space-between">
																{t("DISCOUNT_APPLIED")} <b>{currencyFormatter(props.cartData[0].discount)}</b>
															</Grid>
														)} */}
                            {props.cartData &&
                              props.cartData.length > 0 &&
                              props.cartData[0].totalDiscount &&
                              props.cartData[0].totalDiscount
                                .totalDepositDiscount && (
                                <Grid
                                  item
                                  justifyContent="space-between"
                                  size={{
                                    xs: 12,
                                  }}
                                >
                                  {t("DUE_NOW")}{" "}
                                  <b>
                                    {currencyFormatter(
                                      props.cartData[0].totalDiscount
                                        .totalDepositDiscount,
                                    )}
                                  </b>
                                </Grid>
                              )}
                            {props.cartData &&
                              props.cartData.length > 0 &&
                              props.cartData[0].totalDiscount &&
                              props.cartData[0].totalDiscount
                                .totalOTCDiscount && (
                                <Grid
                                  item
                                  justifyContent="space-between"
                                  size={{
                                    xs: 12,
                                  }}
                                >
                                  {t("DUE_AT_INSTALLATION")}{" "}
                                  <b>
                                    {currencyFormatter(
                                      props.cartData[0].totalDiscount
                                        .totalOTCDiscount,
                                    )}
                                  </b>
                                </Grid>
                              )}
                            {props.cartData &&
                              props.cartData.length > 0 &&
                              props.cartData[0].totalDiscount &&
                              props.cartData[0].totalDiscount
                                .totalRecurringDiscount && (
                                <Grid
                                  item
                                  justifyContent="space-between"
                                  size={{
                                    xs: 12,
                                  }}
                                >
                                  {t("RECURRING_CHARGES")}{" "}
                                  <b>
                                    {currencyFormatter(
                                      props.cartData[0].totalDiscount
                                        .totalRecurringDiscount,
                                    )}
                                  </b>
                                </Grid>
                              )}
                            {props.cartData &&
                              props.cartData.length > 0 &&
                              props.cartData[0].totalDiscount &&
                              props.cartData[0].totalDiscount
                                .totalCancelDiscount && (
                                <Grid
                                  item
                                  justifyContent="space-between"
                                  size={{
                                    xs: 12,
                                  }}
                                >
                                  {t("CANCELLATION_PRICE")}{" "}
                                  <b>
                                    {currencyFormatter(
                                      props.cartData[0].totalDiscount
                                        .totalCancelDiscount,
                                    )}
                                  </b>
                                </Grid>
                              )}
                            {props.cartData &&
                              props.cartData.length > 0 &&
                              props.cartData[0].totalDiscount &&
                              props.cartData[0].totalDiscount
                                .totalShiftDiscount && (
                                <Grid
                                  item
                                  justifyContent="space-between"
                                  size={{
                                    xs: 12,
                                  }}
                                >
                                  {t("SHIFT_PRICE")}{" "}
                                  <b>
                                    {currencyFormatter(
                                      props.cartData[0].totalDiscount
                                        .totalShiftDiscount,
                                    )}
                                  </b>
                                </Grid>
                              )}
                            {props.cartData &&
                              props.cartData.length > 0 &&
                              props.cartData[0].totalDiscount &&
                              props.cartData[0].totalDiscount
                                .totalUsagesDiscount && (
                                <Grid
                                  item
                                  justifyContent="space-between"
                                  size={{
                                    xs: 12,
                                  }}
                                >
                                  {t("USAGE_CHARGE")}{" "}
                                  <b>
                                    {currencyFormatter(
                                      props.cartData[0].totalDiscount
                                        .totalUsagesDiscount,
                                    )}
                                  </b>
                                </Grid>
                              )}
                          </Grid>
                        </Card>
                      </Grid>
                    )}
                  {props.providerType !== "SOLUTION_PROVIDER" && (
                    <Grid
                      item
                      size={{
                        xs: 12,
                      }}
                    >
                      <Card
                        variant="outlined"
                        className={"roundCorners " + classes.totalsCard}
                      >
                        <b>{t("TOTAL_SUMMARY")}</b>
                        <Grid container spacing={1}>
                          <Grid
                            item
                            justifyContent="space-between"
                            size={{
                              xs: 12,
                            }}
                          >
                            {t("DUE_NOW")}{" "}
                            <b>
                              {props.cartData &&
                                props.cartData.length > 0 &&
                                props.cartData[0].cartTotalPrice &&
                                props.cartData[0].cartTotalPrice.length > 0 &&
                                currencyFormatter(priceDueNow)}
                            </b>
                          </Grid>
                          <Grid
                            item
                            justifyContent="space-between"
                            size={{
                              xs: 12,
                            }}
                          >
                            {t("DUE_AT_INSTALLATION")}{" "}
                            <b>
                              {props.cartData &&
                                props.cartData.length > 0 &&
                                props.cartData[0].cartTotalPrice &&
                                props.cartData[0].cartTotalPrice.length > 0 &&
                                currencyFormatter(priceDueAtInstallation)}
                            </b>
                          </Grid>
                          {priceNTCtotal
                            .slice()
                            .sort((chargeA, chargeB) => {
                              const termUOMOrder = [
                                "TF_hr",
                                "TF_day",
                                "TF_wk",
                                "TF_mon",
                                "TF_yr",
                              ];
                              const indexA = termUOMOrder.indexOf(
                                chargeA.tenureUom,
                              );
                              const indexB = termUOMOrder.indexOf(
                                chargeB.tenureUom,
                              );
                              return indexA - indexB;
                            })
                            .map((charge, index) => {
                              const { key, termPeriod, tenureUom, price } =
                                charge;
                              const displayText =
                                termPeriod > 1
                                  ? `${t("NTC_CHARGES")} (per ${getPriceTenureUOM(tenureUom)} for ${termPeriod} ${getPriceTenureUOM(tenureUom)}s)`
                                  : `${t("NTC_CHARGES")} (per ${getPriceTenureUOM(tenureUom)} for ${termPeriod} ${getPriceTenureUOM(
                                    tenureUom,
                                  )})`;
                              return (
                                price > 0 && (
                                  <Grid
                                    item
                                    key={index}
                                    justifyContent="space-between"
                                    size={{
                                      xs: 12,
                                    }}
                                  >
                                    <span>{displayText}</span>
                                    <b>{currencyFormatter(price)}</b>
                                  </Grid>
                                )
                              );
                            })}
                          {priceRecurringChargeTotal
                            .slice()
                            .sort((chargeA, chargeB) => {
                              const termUOMOrder = [
                                "TF_hr",
                                "TF_day",
                                "TF_wk",
                                "TF_mon",
                                "TF_yr",
                              ];
                              const indexA = termUOMOrder.indexOf(
                                chargeA.tenureUom,
                              );
                              const indexB = termUOMOrder.indexOf(
                                chargeB.tenureUom,
                              );
                              return indexA - indexB;
                            })
                            .map((charge, index) => {
                              const { key, termPeriod, tenureUom, price } =
                                charge;
                              const displayText =
                                termPeriod > 1
                                  ? `${t("RECURRING_CHARGES")} (per ${termPeriod} ${getPriceTenureUOM(tenureUom)}s)`
                                  : `${t("RECURRING_CHARGES")} (per ${getPriceTenureUOM(tenureUom)})`;

                              return (
                                price > 0 && (
                                  <Grid
                                    item
                                    key={index}
                                    justifyContent="space-between"
                                    size={{
                                      xs: 12,
                                    }}
                                  >
                                    <span>{displayText}</span>
                                    <b>{currencyFormatter(price)}</b>
                                  </Grid>
                                )
                              );
                            })}
                          {props.type === "CancelSubscription" && (
                            <>
                              <Grid
                                item
                                justifyContent="space-between"
                                size={{
                                  xs: 12,
                                }}
                              >
                                {t("CANCELLATION_PRICE")}{" "}
                                <b>
                                  {props.cartData &&
                                    props.cartData.length > 0 &&
                                    props.cartData[0].cartTotalPrice &&
                                    props.cartData[0].cartTotalPrice.length >
                                    0 &&
                                    currencyFormatter(cancellationPriceTotal)}
                                </b>
                              </Grid>
                            </>
                          )}
                          {props.type === "ShiftSubscription" && (
                            <>
                              <Grid
                                item
                                justifyContent="space-between"
                                size={{
                                  xs: 12,
                                }}
                              >
                                {t("SHIFT_PRICE")}{" "}
                                <b>
                                  {props.cartData &&
                                    props.cartData.length > 0 &&
                                    props.cartData[0].cartTotalPrice &&
                                    props.cartData[0].cartTotalPrice.length >
                                    0 &&
                                    currencyFormatter(shiftPriceTotal)}
                                </b>
                              </Grid>
                            </>
                          )}
                        </Grid>
                      </Card>
                    </Grid>
                  )}

                  <Grid
                    item
                    size={{
                      xs: 12,
                    }}
                  >
                    <Card
                      variant="outlined"
                      className={"roundCorners " + classes.totalsCard}
                    >
                      <b>{t("NOTES")}</b>
                      <>
                        <Grid container spacing={1}>
                          <Grid
                            item
                            style={{ marginTop: "0px" }}
                            size={{
                              xs: 12,
                            }}
                          >
                            {props.cartData &&
                              props.cartData.length > 0 &&
                              props.cartData[0].quoteStatus !==
                              "QUO_APPROVED" &&
                              props.cartData[0].quoteStatus !==
                              "QUO_ORDERED" && (
                                <>
                                  <div
                                    style={{
                                      display: "block",
                                      marginTop: "0px",
                                      width: "100%",
                                    }}
                                  >
                                    <Input
                                      size={"small"}
                                      name={"notes"}
                                      variant={"outlined"}
                                      // placeholder={this.props.t("NOTES")}
                                      //label={<Label label={props.t('NOTES')} edit={props.edit} stage={props.stage}/>}
                                      value={props.notes}
                                      onChange={props.changeNotes}
                                      //inputProps={{ rows: "5", cols: "10", disabled: true }}
                                      inputProps={{
                                        multiline: true,
                                        rows: 5,
                                        cols: 10,
                                        disabled: false,
                                      }}
                                    />
                                    <div
                                      style={{
                                        display: "block",
                                        marginTop: "15px",
                                        width: "100%",
                                        textAlign: "right",
                                      }}
                                    >
                                      <Button
                                        onClick={() => {
                                          props.confirmQuote(true);
                                        }}
                                        disabled={!props.userPerms.includes("ORDERMGR_UPDATE") || !props.userPerms.includes("ORDERMGR_ADMIN") || !props.userPerms.includes("ORDERMGR_CREATE")}
                                      >
                                        {t("ADD_NOTE")}
                                      </Button>
                                    </div>
                                  </div>
                                </>
                              )}
                          </Grid>
                          {/* {props.comments && props.comments.length > 0 && ( */}
                          {newestNotes && newestNotes.length > 0 && (
                            <>
                              {newestNotes.map((item) => (
                                <Grid
                                  item
                                  className={
                                    "roundCorners borderOutline " +
                                    classes.cartItemContainer
                                  }
                                  style={{
                                    marginBottom: ".5rem",
                                    marginTop: ".5rem",
                                  }}
                                  size={{
                                    xs: 12,
                                  }}
                                >
                                  <div
                                    style={{
                                      padding: "0rem 1rem",
                                      display: "initial",
                                      whiteSpace: "pre-line",
                                    }}
                                  >
                                    {item.text.length > 150 ? (
                                      <>
                                        {item.text.substring(0, 150) + "..."}{" "}
                                        <u
                                          style={{
                                            cursor: "pointer",
                                            fontStyle: "italic",
                                          }}
                                          onClick={() => showFullNote(item)}
                                        >
                                          {t("READ_MORE")}
                                        </u>
                                      </>
                                    ) : (
                                      item.text
                                    )}
                                  </div>
                                  <div
                                    style={{
                                      fontStyle: "italic",
                                      fontWeight: "bold",
                                      padding: "0rem 1rem",
                                    }}
                                  >
                                    {item.addedBy} <br />
                                    {formatDate(item.dateTime)}
                                  </div>
                                </Grid>
                              ))}
                              {props.comments.length > 3 && (
                                <div
                                  style={{
                                    marginTop: "1rem",
                                    justifyContent: "flex-end",
                                    width: "100%",
                                  }}
                                >
                                  <Button
                                    className="buttonSecondary"
                                    onClick={handleOpenAllNotes}
                                  >
                                    {t("VIEW_ALL_NOTES")}
                                  </Button>
                                </div>
                              )}
                            </>
                          )}
                        </Grid>
                      </>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>
            </>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
      </Grid>
      {props.priceSummaryView ? (
        <></>
      ) : (
        <Card variant="outlined" className={"roundCorners"}>
          <TableContainer>
            <Table className={"newGlobalTable"}>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: "40px" }}>
                    {t("QUANTITY_SHORT")}
                  </TableCell>
                  <TableCell colSpan={2}>{t("ITEM")}</TableCell>
                  <TableCell></TableCell>
                  {props.orderStatus === "ORDER_COMPLETED" ? (
                    <TableCell>{t("BILLING_REF")} #</TableCell>
                  ) : null}
                  {props.screen &&
                    props.screen === "checkout" &&
                    props.providerType === "SALES_CHNL_PROVIDER" && (
                      <TableCell>{t("CLIENT")}</TableCell>
                    )}
                  {props.providerType === "SALES_CHNL_PROVIDER" ? (
                    <>
                      <Tooltip title={t("TODAY_COST_TITLE")}>
                        <TableCell align="right">{t("TODAY_COST")}</TableCell>
                      </Tooltip>
                      <Tooltip title={t("RECURRING_COST_TITLE")}>
                        <TableCell align="right" style={{ paddingRight: 10 }}>
                          {t("RECURRING_COST")}
                        </TableCell>
                      </Tooltip>
                    </>
                  ) : (
                    <>
                      <TableCell>&nbsp;</TableCell>
                      <TableCell>&nbsp;</TableCell>
                    </>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {props.cartData &&
                  props.cartData.length > 0 &&
                  props.cartData[0].cartItem &&
                  props.cartData[0].cartItem.length > 0 &&
                  props.cartData[0].cartItem.map((item, index) =>
                    item.productOffering.sellable ? (
                      <React.Fragment key={index}>
                        <TableRow>
                          <TableCell>
                            <div className={classes.compQtyLabel}>
                              {props.edit.quantity && item.editable ? (
                                <Input
                                  className={classes.quantityInput}
                                  type="number"
                                  min="1"
                                  step="1"
                                  value={item.productOffering.quantity}
                                  onChange={(e) => {
                                    props.changeQuantity(e, item);
                                  }}
                                  style={{ background: "#fff" }}
                                />
                              ) : (
                                <b>{formatNumber(item.productOffering.quantity)}</b>
                              )}
                            </div>
                            {/* End: Packaged Solution info */}
                          </TableCell>
                          <TableCell colSpan={2}>
                            <b>{item.productOffering.name}</b>
                          </TableCell>
                          <TableCell></TableCell>
                          {props.orderStatus === "ORDER_COMPLETED" && (
                            <TableCell>{props.pcoSeqNum}</TableCell>
                          )}
                          {props.screen &&
                            props.screen === "checkout" &&
                            props.providerType === "SALES_CHNL_PROVIDER" && (
                              <TableCell>
                                {item.productOffering.locationDetail &&
                                  item.productOffering.locationDetail.partyId ? (
                                  <>
                                    {props.orderStatus === "ORDER_COMPLETED" ? (
                                      item.productOffering.locationDetail.name
                                    ) : (
                                      <>
                                        {
                                          item.productOffering.locationDetail
                                            .name
                                        }{" "}
                                        &nbsp; &nbsp;
                                        <span
                                          style={{
                                            color: props.tenantData.color,
                                          }}
                                        >
                                          <Tooltip title={props.t("CHANGE")}>
                                            <EditIcon
                                              onClick={() =>
                                                props.selectItem(
                                                  item.index,
                                                  item.productOffering.id,
                                                  "edit",
                                                )
                                              }
                                            />
                                          </Tooltip>
                                          <Tooltip title={props.t("CLEAR")}>
                                            <ClearIconMUI
                                              onClick={() =>
                                                props.selectItem(
                                                  item.index,
                                                  item.productOffering.id,
                                                  "delete",
                                                )
                                              }
                                            />
                                          </Tooltip>
                                        </span>
                                      </>
                                    )}
                                  </>
                                ) : props.orderStatus === "ORDER_COMPLETED" ? (
                                  ""
                                ) : (
                                  <span
                                    style={{ color: props.tenantData.color }}
                                  >
                                    <Tooltip title={props.t("ADD")}>
                                      <AddIcon
                                        onClick={() =>
                                          props.selectItem(
                                            item.index,
                                            item.productOffering.id,
                                            "add",
                                          )
                                        }
                                      />
                                    </Tooltip>
                                  </span>
                                )}
                              </TableCell>
                            )}
                          {props.providerType === "SALES_CHNL_PROVIDER" ? (
                            <React.Fragment>
                              {item.productOffering.includedItems.map(
                                (aItem, aIndex) => (
                                  <>
                                    <TableCell align="right">
                                      {aItem.priceType === "NR"
                                        ? currencyFormatter(
                                          (aItem.specialPrice
                                            ? aItem.specialPrice
                                            : aItem.price) *
                                          aItem.quantity *
                                          item.productOffering.quantity,
                                        )
                                        : currencyFormatter(0)}
                                    </TableCell>
                                    <TableCell align="right">
                                      {aItem.priceType === "RC"
                                        ? currencyFormatter(
                                          (aItem.specialPrice
                                            ? aItem.specialPrice
                                            : aItem.price) *
                                          aItem.quantity *
                                          item.productOffering.quantity,
                                        )
                                        : currencyFormatter(0)}
                                    </TableCell>
                                  </>
                                ),
                              )}
                            </React.Fragment>
                          ) : (
                            <>
                              <TableCell>&nbsp;</TableCell>
                              <TableCell>&nbsp;</TableCell>
                            </>
                          )}
                        </TableRow>
                        {item.productOffering.includedItems[0].bom &&
                          item.productOffering.includedItems[0].bom.length >
                          0 && (
                            <TableRow>
                              <TableCell
                                colSpan={
                                  props.orderStatus === "ORDER_COMPLETED"
                                    ? 8
                                    : 7
                                }
                              >
                                <Collapse in={true}>
                                  {item.productOffering.includedItems[0].bom
                                    .sort((a, b) =>
                                      a && b
                                        ? a.displaySequence - b.displaySequence
                                        : 0,
                                    )
                                    .map((bom, index) => (
                                      <div
                                        key={bom.id}
                                        style={{
                                          marginLeft: "93px",
                                          marginRight: "36px",
                                        }}
                                      >
                                        <BomItem
                                          data={bom}
                                          index={index}
                                          t={t}
                                          parentItem={
                                            item.productOffering
                                              .includedItems[0]
                                          }
                                          level={1}
                                        />
                                      </div>
                                    ))}
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          )}
                      </React.Fragment>
                    ) : (
                      <React.Fragment key={index}>
                        <TableRow>
                          <TableCell>
                            <div className={classes.compQtyLabel}>
                              {props.edit.quantity ? (
                                <Input
                                  className={classes.quantityInput}
                                  type="number"
                                  min="1"
                                  step="1"
                                  value={item.productOffering.quantity}
                                  onChange={(e) => {
                                    props.changeQuantity(e, item);
                                  }}
                                  style={{ background: "#fff" }}
                                />
                              ) : (
                                <b>{formatNumber(item.productOffering.quantity)}</b>
                              )}
                            </div>
                            {/* End: Packaged Solution info */}
                          </TableCell>
                          <TableCell colSpan={2}>
                            <b>{item.productOffering.name}</b>
                          </TableCell>
                          <TableCell></TableCell>
                          {props.orderStatus === "ORDER_COMPLETED" ? (
                            <TableCell align="right"></TableCell>
                          ) : null}
                          {props.screen &&
                            props.screen === "checkout" &&
                            props.providerType === "SALES_CHNL_PROVIDER" && (
                              <TableCell>
                                {item.productOffering.locationDetail &&
                                  item.productOffering.locationDetail.partyId ? (
                                  <>
                                    {props.orderStatus === "ORDER_COMPLETED" ? (
                                      item.productOffering.locationDetail.name
                                    ) : (
                                      <>
                                        {
                                          item.productOffering.locationDetail
                                            .name
                                        }{" "}
                                        &nbsp; &nbsp;
                                        <span
                                          style={{
                                            color: props.tenantData.color,
                                          }}
                                        >
                                          <Tooltip title={props.t("CHANGE")}>
                                            <EditIcon
                                              onClick={() =>
                                                props.selectItem(
                                                  item.index,
                                                  item.productOffering.id,
                                                  "edit",
                                                )
                                              }
                                            />
                                          </Tooltip>
                                          <Tooltip title={props.t("CLEAR")}>
                                            <ClearIconMUI
                                              onClick={() =>
                                                props.selectItem(
                                                  item.index,
                                                  item.productOffering.id,
                                                  "delete",
                                                )
                                              }
                                            />
                                          </Tooltip>
                                        </span>
                                      </>
                                    )}
                                  </>
                                ) : props.orderStatus === "ORDER_COMPLETED" ? (
                                  ""
                                ) : (
                                  <span
                                    style={{ color: props.tenantData.color }}
                                  >
                                    <Tooltip title={props.t("ADD")}>
                                      <AddIcon
                                        onClick={() =>
                                          props.selectItem(
                                            item.index,
                                            item.productOffering.id,
                                            "add",
                                          )
                                        }
                                      />
                                    </Tooltip>
                                  </span>
                                )}
                              </TableCell>
                            )}
                          {props.providerType === "SALES_CHNL_PROVIDER" ? (
                            <>
                              <TableCell align="right"></TableCell>
                              <TableCell align="right"></TableCell>
                            </>
                          ) : (
                            <>
                              <TableCell>&nbsp;</TableCell>
                              <TableCell>&nbsp;</TableCell>
                            </>
                          )}
                        </TableRow>
                        {/* Fetch all components */}

                        {item.productOffering.includedItems.map(
                          (aItem, aIndex) =>
                            checkFulfillable(aItem.fulfillable) &&
                            aItem.customerViewable && (
                              <>
                                <TableRow
                                  key={aIndex}
                                  className="associatedItems-wrapperDiv"
                                  style={{ color: "#4a4a4a !important" }}
                                >
                                  <TableCell>&nbsp;</TableCell>
                                  <TableCell>
                                    {formatNumber(aItem.quantity *
                                      item.productOffering.quantity)}
                                  </TableCell>
                                  <TableCell>
                                    {aItem.name}&nbsp;
                                    {props.providerType ===
                                      "SALES_CHNL_PROVIDER" && (
                                        <>
                                          (
                                          {formatNumber(aItem.quantity *
                                            item.productOffering.quantity)} {" "}
                                          x{" "}
                                          {currencyFormatter(
                                            aItem.specialPrice
                                              ? aItem.specialPrice
                                              : aItem.price,
                                          )}
                                          )
                                        </>
                                      )}
                                  </TableCell>
                                  {(props.loggedInUserType !==
                                    "ECOMMERCE_CUSTOMER" ||
                                    props.loggedInUserType !==
                                    "ECOMMERCE_ADMIN") && (
                                      <TableCell>{/* Discount Cell */}</TableCell>
                                    )}
                                  {props.orderStatus === "ORDER_COMPLETED" && (
                                    <TableCell>{props.pcoSeqNum}</TableCell>
                                  )}
                                  {props.screen &&
                                    props.screen === "checkout" &&
                                    props.providerType ===
                                    "SALES_CHNL_PROVIDER" && (
                                      <TableCell>
                                        {/* {aItem.locationDetail && aItem.locationDetail.partyId ?
																	<>
																		{props.orderStatus === 'ORDER_COMPLETED' ?
																			aItem.locationDetail.name
																			:
																			<>
																				{aItem.locationDetail.name} &nbsp; &nbsp;
																				<span style={{ color: props.tenantData.color }}>
																					<Tooltip title={props.t('CHANGE')}>
																						<EditIcon onClick={() => props.selectItem(item.id, aItem.id, 'edit')} />
																					</Tooltip>
																					<Tooltip title={props.t('CLEAR')}>
																						<ClearIconMUI onClick={() => props.selectItem(item.id, aItem.id, 'delete')} />
																					</Tooltip>
																				</span>
																			</>
																		}
																	</>
																	:
																	props.orderStatus === 'ORDER_COMPLETED' ? '' :
																		<span style={{ color: props.tenantData.color }}>
																			<Tooltip title={props.t('ADD')}>
																				<AddIcon onClick={() => props.selectItem(item.id, aItem.id, 'add')} />
																			</Tooltip>
																		</span>
																} */}
                                      </TableCell>
                                    )}
                                  {props.providerType ===
                                    "SALES_CHNL_PROVIDER" ? (
                                    <>
                                      <TableCell align="right">
                                        {aItem.priceType === "NR" ||
                                          aItem.priceType === "NTC"
                                          ? currencyFormatter(
                                            (aItem.specialPrice
                                              ? aItem.specialPrice
                                              : aItem.price) *
                                            aItem.quantity *
                                            item.productOffering.quantity,
                                          )
                                          : currencyFormatter(0)}
                                      </TableCell>
                                      <TableCell align="right">
                                        {aItem.priceType === "RC"
                                          ? currencyFormatter(
                                            (aItem.specialPrice
                                              ? aItem.specialPrice
                                              : aItem.price) *
                                            aItem.quantity *
                                            item.productOffering.quantity,
                                          )
                                          : currencyFormatter(0)}
                                      </TableCell>
                                    </>
                                  ) : (
                                    <>
                                      <TableCell>&nbsp;</TableCell>
                                      <TableCell>&nbsp;</TableCell>
                                    </>
                                  )}
                                </TableRow>
                                {aItem.bom && aItem.bom.length > 0 && (
                                  <TableRow>
                                    <TableCell
                                      colSpan={
                                        props.orderStatus === "ORDER_COMPLETED"
                                          ? 8
                                          : 7
                                      }
                                    >
                                      <Collapse in={true}>
                                        {aItem.bom
                                          .sort((a, b) =>
                                            a && b
                                              ? a.displaySequence -
                                              b.displaySequence
                                              : 0,
                                          )
                                          .map((bom, index) => (
                                            <div
                                              key={bom.id}
                                              style={{
                                                marginLeft: "153px",
                                                marginRight: "36px",
                                              }}
                                            >
                                              <BomItem
                                                data={bom}
                                                index={index}
                                                parentItem={aItem}
                                                level={1}
                                                t={t}
                                              />
                                            </div>
                                          ))}
                                      </Collapse>
                                    </TableCell>
                                  </TableRow>
                                )}
                              </>
                            ),
                        )}
                        {props.providerType === "SALES_CHNL_PROVIDER" &&
                          item.discountDetails &&
                          item.discountDetails.value && (
                            <TableRow className="associatedItems-wrapperDiv">
                              <TableCell>&nbsp;</TableCell>
                              <TableCell>&nbsp;</TableCell>
                              <TableCell>
                                <span
                                  style={{
                                    display: "block",
                                    fontWeight: "bold",
                                    fontStyle: "italic",
                                  }}
                                >
                                  {item.discountDetails.value}% {t("DISCOUNT")}
                                </span>
                              </TableCell>
                              {(props.loggedInUserType !==
                                "ECOMMERCE_CUSTOMER" ||
                                props.loggedInUserType !==
                                "ECOMMERCE_ADMIN") && (
                                  <TableCell>{/* Discount Cell */}</TableCell>
                                )}
                              {props.orderStatus === "ORDER_COMPLETED" && (
                                <TableCell></TableCell>
                              )}
                              {props.screen &&
                                props.screen === "checkout" &&
                                props.providerType ===
                                "SALES_CHNL_PROVIDER" && (
                                  <TableCell></TableCell>
                                )}
                              <TableCell align="right">
                                -{" "}
                                {currencyFormatter(
                                  item.discountDetails.nrDiscount,
                                )}
                                {/* {(aItem.priceType === 'NR') ? currencyFormatter(((aItem.specialPrice ? aItem.specialPrice : aItem.price) * aItem.quantity) * item.productOffering.quantity) : currencyFormatter(0)} */}
                              </TableCell>
                              <TableCell align="right">
                                -{" "}
                                {currencyFormatter(
                                  item.discountDetails.rcDiscount,
                                )}
                                {/* {(aItem.priceType === 'RC') ? currencyFormatter(((aItem.specialPrice ? aItem.specialPrice : aItem.price) * aItem.quantity) * item.productOffering.quantity) : currencyFormatter(0)} */}
                              </TableCell>
                            </TableRow>
                          )}
                      </React.Fragment>
                    ),
                  )}
                {props.providerType === "SALES_CHNL_PROVIDER" && (
                  <>
                    <TableRow className={classes.totalCostRow}>
                      <TableCell></TableCell>
                      {props.orderStatus === "ORDER_COMPLETED" ? (
                        <TableCell
                          colSpan={
                            props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                              props.loggedInUserType !== "ECOMMERCE_ADMIN"
                              ? 4
                              : 3
                          }
                        >
                          {t("TOTALS")}
                        </TableCell>
                      ) : (
                        <TableCell
                          colSpan={
                            props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                              props.loggedInUserType !== "ECOMMERCE_ADMIN"
                              ? 3
                              : 2
                          }
                        >
                          {t("TOTALS")}
                        </TableCell>
                      )}
                      {/* {(props.loggedInUserType === 'ECOMMERCE_CUSTOMER' || props.loggedInUserType === 'ECOMMERCE_ADMIN') &&
										// <TableCell></TableCell>
									} */}
                      {props.screen &&
                        props.screen === "checkout" &&
                        props.providerType === "SALES_CHNL_PROVIDER" && (
                          <TableCell></TableCell>
                        )}
                      <TableCell align="right" className="totalCost">
                        {props.cartData &&
                          props.cartData.length > 0 &&
                          props.cartData[0].cartTotalPrice &&
                          props.cartData[0].cartTotalPrice.length > 0 &&
                          props.cartData[0].cartTotalPrice.map(
                            (price) =>
                              price.priceType === "NR" &&
                              currencyFormatter(price.price),
                          )}
                      </TableCell>
                      <TableCell
                        align="right"
                        className="monthlyCost"
                        style={{ paddingRight: 10 }}
                      >
                        {props.cartData &&
                          props.cartData.length > 0 &&
                          props.cartData[0].cartTotalPrice &&
                          props.cartData[0].cartTotalPrice.length > 0 &&
                          props.cartData[0].cartTotalPrice.map(
                            (price) =>
                              price.priceType === "RC" &&
                              currencyFormatter(price.price),
                          )}
                      </TableCell>
                    </TableRow>

                    {/* Discounted Total Row  */}
                    {/* {totalDiscount > 0 && (nowDiscountedPrice > 0 || recDiscountedPrice > 0) &&
									<>
										<TableRow className={classes.totalCostRow}>
											<TableCell></TableCell>
											{(props.orderStatus === 'ORDER_COMPLETED') ?
												<TableCell colSpan={4}>{t('TOTAL_DISCOUNT')}</TableCell>
												:
												<TableCell colSpan={3}>{t('TOTAL_DISCOUNT')}</TableCell>
											}
											{nowDiscountedPrice &&
												<TableCell align="right" className="totalCost">
													{currencyFormatter(((Math.round(nowTotal * 100) / 100) - nowDiscountedPrice).toFixed(2))}
												</TableCell>
											}
											<TableCell align="right" className="monthlyCost">
												{recDiscountedPrice
													?
													(parseInt(recDiscountedPrice) === 0) ? '' : currencyFormatter(((Math.round(recTotal * 100) / 100) - recDiscountedPrice).toFixed(2))
													:
													currencyFormatter('', false) + '0.00'
												}
											</TableCell>
										</TableRow>
										<TableRow className={classes.totalCostRow}>
											<TableCell></TableCell>
											{(props.orderStatus === 'ORDER_COMPLETED') ?
												<TableCell colSpan={4}>{t('ORDER_TOTAL_AFTER_DISCOUNT')}</TableCell>
												:
												<TableCell colSpan={3}>{t('ORDER_TOTAL_AFTER_DISCOUNT')}</TableCell>
											}
											{nowDiscountedPrice && <TableCell align="right" className="totalCost">{currencyFormatter(nowDiscountedPrice)}</TableCell>}
											<TableCell align="right" className="monthlyCost">
												{recDiscountedPrice
													?
													(parseInt(recDiscountedPrice) === 0) ? '' : currencyFormatter(recDiscountedPrice)
													:
													currencyFormatter('', false) + '0.00'
												}
											</TableCell>
										</TableRow>
									</>
								} */}
                  </>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      )}
      {showNote && (
        <ShowNoteDialog note={noteData} open={showNote} close={closeFullNote} />
      )}
      {/* Dialog to show all notes */}
      <Dialog
        open={allNotesOpen}
        PaperComponent={DraggableDialogPaper}
        onClose={handleCloseAllNotes}
        maxWidth="md"
        fullWidth={true}
      // PaperProps={{
      // 	className: classess.resizablePaper
      // }}
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          <div style={{ display: "flex" }}>
            <span style={{ display: "inline-flex", width: "95%" }}>
              {t("ALL_NOTES")}
            </span>
            <Tooltip
              title={t("CLOSE")}
              id="show-all-notes-dialog"
              style={{ cursor: "move" }}
            >
              <IconButton
                onTouchStart={handleCloseAllNotes}
                onClick={handleCloseAllNotes}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            {props.comments && props.comments.length > 0 ? (
              <>
                <Grid container spacing={1}>
                  {props.comments.map((item) => (
                    <Grid
                      item
                      className={
                        "roundCorners borderOutline " +
                        classes.cartItemContainer
                      }
                      style={{ marginBottom: ".5rem" }}
                      size={{
                        xs: 12,
                      }}
                    >
                      <div
                        style={{
                          padding: "0rem 1rem",
                          display: "initial",
                          whiteSpace: "pre-line",
                        }}
                      >
                        {item.text.length > 150 ? (
                          <>
                            {item.text.substring(0, 150) + "..."}{" "}
                            <u
                              style={{ cursor: "pointer", fontStyle: "italic" }}
                              onClick={() => showFullNote(item)}
                            >
                              {t("READ_MORE")}
                            </u>
                          </>
                        ) : (
                          item.text
                        )}
                      </div>
                      {/* <div style={{ fontStyle: "italic", fontWeight: "bold", padding: "0rem 1rem" }}>{item.author}</div> */}
                      <div
                        style={{
                          fontStyle: "italic",
                          fontWeight: "bold",
                          padding: "0rem 1rem",
                        }}
                      >
                        {item.author} <br />
                        {item.dateTime && formatDate(item.dateTime)}
                      </div>
                    </Grid>
                  ))}
                </Grid>
              </>
            ) : (
              props.status === "Order Fulfilled" && (
                <>
                  <div style={{ marginTop: "1rem" }}>
                    {props.t("NO_DATA_AVAILABLE")}
                  </div>
                </>
              )
            )}
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
};

const SellableClientColumn = (props) => {
  const [showHierarchy, toggleShowHierarchy] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [mode, setmode] = useState("ADD");
  useEffect(() => {
    if (props.locationDetail && props.locationDetail.partyId) {
      setSelectedCustomer([props.locationDetail]);
    }
  }, []);
  const DraggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };
  const selectCustomers = (data) => {
    toggleShowHierarchy(false);
    props.updateLineItemClient(props.index, props.id, data.partyId, mode);
    setmode("ADD");
  };
  const editCustomer = () => {
    setmode("MODIFY");
    toggleShowHierarchy(true);
  };
  const clearCustomer = () => {
    props.updateLineItemClient(
      props.index,
      props.id,
      selectedCustomer[0].partyId,
      "DELETE",
    );
    // setSelectedCustomer([]);
    // props.clearCustomer(props.orderItemSeqId, selectedCustomer[0].partyId, 'DELETE')
  };
  return (
    <>
      <TableCell>
        {selectedCustomer && selectedCustomer.length > 0 ? (
          <>
            <span style={{ position: "relative", top: "-5px" }}>
              {selectedCustomer[0].name}
            </span>
            {props.providerType === "SALES_CHNL_PROVIDER" &&
              props.editOptions &&
              props.editOptions.location ? (
              <>
                &nbsp; &nbsp;
                <span style={{ color: props.tenantData.color }}>
                  <Tooltip title={props.t("CHANGE")}>
                    <EditIcon onClick={() => editCustomer()} />
                  </Tooltip>
                  <Tooltip title={props.t("CLEAR")}>
                    <ClearIconMUI onClick={() => clearCustomer()} />
                  </Tooltip>
                </span>
              </>
            ) : (
              ""
            )}
          </>
        ) : (
          <>
            {props.providerType === "SALES_CHNL_PROVIDER" &&
              props.editOptions &&
              props.editOptions.location ? (
              <span style={{ color: props.tenantData.color }}>
                <Tooltip title={props.t("ADD")}>
                  <AddIcon onClick={() => toggleShowHierarchy(true)} />
                </Tooltip>
              </span>
            ) : (
              ""
            )}
          </>
        )}
      </TableCell>
      {showHierarchy && (
        <Dialog
          disableScrollLock={true}
          maxWidth={"sm"}
          PaperComponent={DraggableDialogPaper}
          fullWidth={true}
          open={showHierarchy}
          aria-labelledby="import-dialog-title"
        // PaperProps={{
        // 	className: props.classess.resizablePaper
        // }}
        >
          <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
            {props.t("SELECT_CUSTOMER")}
          </DialogTitle>
          <DialogContent dividers style={{ height: "500px" }}>
            <ManageCustomersHierarchy
              screen="products"
              subScreen="oldOfferingFilter"
              selectCustomers={selectCustomers}
              customerData={selectedCustomer}
              offeringBan={props.orderCustomer.ban}
            // offeringCustomer={[props.orderCustomer.clientId]}
            // stage={this.state.stage}
            // next={this.selectCustomerClose}
            // // back={this.back}
            // selectedTreeItems={this.state.selectedTreeItems}
            // customerDetails={this.state.customerDetails}
            // selectedPaymentMethod={this.state.selectedPaymentMethod}
            // resetSelecteddata={this.resetSelecteddata}
            // closeDialog={this.closeDialog}
            // parentTenantId={this.state.parentTenantId}

            // offeringCustomer={(this.props.ecommerceCustData && this.props.ecommerceCustData.partyId) ? [this.props.ecommerceCustData.partyId] : this.state.offeringCustomersList}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => toggleShowHierarchy(false)}>
              {props.t("CANCEL")}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};
const BomItemNew = (bom) => {
  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          paddingLeft: `${(bom.level - 1) * 4}rem`,
          flexDirection: "row",
        }}
      >
        <EnterArrow />
        <div>
          <b> {bom.data.name}</b>
          {bom.t("QUANTITY")}: (
          {bom.data.presetQuantity
            ? formatNumber(bom.data.presetQuantity * bom.parentItem.quantity)
            : formatNumber(1 * bom.parentItem.quantity)}
          )
        </div>
      </div>
      {bom.data.bom &&
        bom.data.bom.length > 0 &&
        bom.data.bom
          .sort((a, b) => (a && b ? a.displaySequence - b.displaySequence : 0))
          .map((child) => (
            <BomItemNew
              data={child}
              parentItem={bom.parentItem}
              level={bom.level + 1}
              t={bom.t}
            />
          ))}
    </div>
  );
};

const BomItem = (bom) => {
  return (
    bom.data.customerViewable && (
      <div
        style={{
          padding: "5px 25px 0",
          paddingTop: bom.index === 0 ? 0 : "5px",
          paddingLeft: bom.level === 1 ? 0 : "60px",
        }}
      >
        <TableContainer>
          <Table style={{ width: "100%" }} className="noPaddingTd">
            <TableBody>
              <TableRow>
                <TableCell style={{ paddingRight: 0 }}>
                  {/* <div style={{ width: '60px', float: 'left' }}>
								<Input
									className={classes.quantityInput}
									value={bom.data.presetQuantity ? bom.data.presetQuantity * bom.parentItem.quantity : 1 * bom.parentItem.quantity}
									disabled={true}
								/>
							</div> */}
                  <div
                    style={{
                      width: "calc(100% - 60px)",
                      float: "left",
                      lineHeight: "28px",
                    }}
                  >
                    {bom.data.name}&nbsp;
                    <span title={bom.t("QUANTITY")}>
                      (
                      {bom.data.presetQuantity
                        ? formatNumber(bom.data.presetQuantity * bom.parentItem.quantity)
                        : formatNumber(1 * bom.parentItem.quantity)}
                      )
                    </span>
                  </div>
                </TableCell>
                {/* <td>
							{bom.data.name}
						</td> */}
                {/* <td style={{ width: '10%', textAlign: 'right' }}>{bom.data.price}</td> */}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        {bom.data.bom &&
          bom.data.bom.length > 0 &&
          bom.data.bom
            .sort((a, b) =>
              a && b ? a.displaySequence - b.displaySequence : 0,
            )
            .map((child) => (
              <BomItem
                data={child}
                parentItem={bom.parentItem}
                level={bom.level + 1}
                t={bom.t}
              />
            ))}
      </div>
    )
  );
};

// Fetch data from redux store
const mapStateToProps = (state) => {
  return {
    quoteEnabled: state.auth.quoteEnabled,
    priceSummaryView: state.auth.priceSummaryView,
    tenantData: state.auth.tenantData,
    providerType: state.auth.providerType,
    userPerms: state.auth.userPerms,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(NewCartBlock));
